import api from '@/legacy/services/api';
import urls from '@/legacy/config/env';
import type { LoginResponseDTO } from '../';

export const loginFakeAccessService = async (
	companyId: number,
	delegationsIds?: number[],
): Promise<LoginResponseDTO> => {
	const response = await api.post<LoginResponseDTO>(urls.auth.loginFakeAccess(companyId), {
		delegations: delegationsIds,
	});
	return response.data;
};
